@if (isNotificationVisible) {
  <div
    class="overlay fixed bottom-0 left-0 top-0 z-50 w-full bg-primary-strong bg-opacity-80"
    (click)="closeNotifications()"
    (keydown)="closeNotifications()"
    tabindex="1"
  ></div>
}
<div
  class="fixed bottom-0 right-0 top-0 z-50 h-full w-4/5 transform rounded-l-xl bg-lightBlue text-primary-strong transition-transform duration-500 md:w-2/5 xl:w-1/5"
  [ngClass]="{ 'translate-x-full': !isNotificationVisible }"
>
  <div class="flex h-full flex-col py-9">
    <!-- Header -->
    <div class="ms:px6 mb-[31px] flex items-center justify-between px-5">
      <button class="flex items-center">
        <img
          src="assets/icons/arrow-left-primary-strong.svg"
          alt="arrow-left"
          (click)="closeNotifications()"
          (keydown)="closeNotifications()"
          tabindex="2"
        />
      </button>
      <h1 class="font-freightSansProBold text-xl">Notificaciones</h1>
      <div class="sm:space-x-2">
        <button
          type="button"
          (click)="UpdateNotifications()"
          [disabled]="disableButtonActions"
          class="duration-600 button-icon-hover h-8 w-8 rounded-lg p-2 transition ease-in-out hover:bg-[#EBF0F5]"
          [hidden]="hideViewButton()"
        >
          <img src="assets/icons/Eyeview-icon.svg" alt="" />
          <img src="assets/icons/Eyeview-hover-icon.svg" alt="" />
        </button>
        <button
          type="button"
          (click)="UpdateNotifications(3)"
          [disabled]="disableButtonActions"
          class="duration-600 button-icon-hover h-8 w-8 rounded-lg p-2 transition ease-in-out hover:bg-[#EBF0F5]"
        >
          <img src="assets/icons/Trush-icon.svg" alt="EyeView" />
          <img src="assets/icons/Trush-hover-icon.svg" alt="EyeView" />
        </button>
      </div>
    </div>
    <!-- Notification Messages Content -->
    @if (notifications.length > 0) {
      <div
        class="flex flex-grow snap-y flex-col space-y-4 overflow-auto overscroll-contain scroll-smooth px-6"
      >
        @for (message of notifications; track message) {
          <app-notification-message
            [notificationDate]="message.date"
            [title]="message.title"
            [body]="message.body"
            [viewed]="message.viewed"
            [notificationId]="message.notificationId"
            [isChecked]="message.checked"
            (checkedChange)="onCheckedChange($event)"
          ></app-notification-message>
        }
      </div>
    } @else {
      <div class="flex items-center px-6">
        <div
          class="flex h-28 w-full items-center justify-center gap-4 rounded-lg bg-[#DCE2EB]"
        >
          <img src="assets/icons/unshield-icon.svg" class="size-6" alt="" />
          <h3 class="font-freightSansProMedium text-base text-primary-normal">
            No tiene notificaciones.
          </h3>
        </div>
      </div>
    }
  </div>
</div>

<!-- NONE QUOTERS MESSAGE -->
